import TableContentItem from "./TableContentItem";
import "./index.scss";

const Table = ({ headerData, contentData, route }) => {
  if (headerData.length === 0) return;
  return (
    <section className="admin-table">
      <ul className="admin-table-header">
        {headerData.map((item) => {
          return <li key={item}>{item}</li>;
        })}
        <li className="empty"></li>
        <li className="empty"></li>
      </ul>
      <div className="admin-table-content">
        {contentData &&
          contentData.map((item) => {
            return (
              <TableContentItem
                key={item._id}
                data={item}
                id={item._id}
                route={route}
              />
            );
          })}
      </div>
    </section>
  );
};

export default Table;
